
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.85 10.213V19.6c0 .69-.56 1.25-1.25 1.25h-4.2a.25.25 0 01-.25-.25V16.39a1.75 1.75 0 00-1.75-1.75h-2.8a1.75 1.75 0 00-1.75 1.75V20.6a.25.25 0 01-.25.25H4.4c-.69 0-1.25-.56-1.25-1.25v-9.387c0-.406.197-.787.53-1.021l7.599-5.365a1.25 1.25 0 011.442 0l7.6 5.365c.332.234.529.615.529 1.021z","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    